import React, { useEffect } from "react";
import icons from "../../assets/images/constantIcons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allOrders } from "./OrderSlice";
import Navbar from "./Navbar";
import images from "../../assets/images/constantImages";

const AllOrders = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { orders = [], loading = false } = useSelector((state) => state.orders || {});
    const canteenUserId = localStorage.getItem('canteen_user_id');

    useEffect(() => {
        dispatch(allOrders())
    }, [dispatch])

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return date.toLocaleString('en-US', options);
    };

    if (loading) return <p>Loading .....</p>
    return (
        <>
            <Navbar />
            <div className="p-4">
                <div className="flex items-center gap-2 text-G500 font-medium mb-4">
                    <icons.IoMdArrowRoundBack
                        onClick={() => navigate(-1)}
                        className="text-G100 text-2xl cursor-pointer"
                    />
                    <p className="text-G800 font-semibold text-2xl cursor-pointer">Orders</p>
                </div>

                <div className="">
                    {/* Order List */}
                    {orders?.length > 0 ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                            {orders?.slice(0, 6).map((order, index) => (
                                <div key={index} className={`${order.status === "pendin" ? "bg-[#FFF9F4]" : order.status === "complete" ? "bg-[#E8FFFF]" : "bg-[#FFF2FB]"} bg-canteencardcolor rounded-2xl p-4 flex flex-col justify-between border-2 border-canteengreen`}>
                                    <div className="flex justify-between text-G500">
                                        <p className="text-lg font-semibold">
                                            Order ID <span>{order.order_uniq_id}</span>
                                        </p>
                                        <p className="text-sm font-medium">{order.user.full_name}</p>
                                    </div>
                                    <div className="flex justify-between text-G100 text-xs mt-2">
                                        <p>{formatDate(order.date)}</p>
                                        <p className="bg-white  text-canteengreen rounded-lg px-2 py-1">
                                            Customer
                                        </p>
                                    </div>
                                    <div className="flex flex-col gap-2 text-G500 text-sm my-2 ">
                                        {order.order_items.map((item, idx) => (
                                            <div
                                                key={idx}
                                                className="flex justify-between items-center gap-3"
                                            >
                                                <div className="flex items-center justify-between ">
                                                    <p className="w-56 flex items-center">
                                                        <img
                                                            src={item.image}
                                                            alt={item.item_name}
                                                            className="w-8 h-8 rounded-full mr-3"
                                                        />
                                                        {item.item_name}
                                                    </p>
                                                    <h1>X{item.quantity}</h1>
                                                </div>
                                                <div className="font-medium">₹ {item.total_price}</div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-auto">
                                        <hr className="border-b-[1px] border-white mb-2" />
                                        <div className="flex justify-between items-center text-G500">
                                            <p className="font-semibold text-lg flex">
                                                <span className="text-canteengreen mr-1">₹</span>
                                                {order.total_price}
                                            </p>
                                            <div className={`text-center text-sm py-[6px] px-4 rounded-md text-white ${order.status === "pending" ? "bg-yellow" : order.status === "cancelled" ? "bg-red" : "bg-green"}`}>
                                                {order.status}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (<div className="flex flex-col justify-center items-center mt-10">
                        <img src={images.noorderimage} alt="noorderimage" className="" />
                        <Link to={`/menus/${canteenUserId}`}>
                            <span className="bg-canteengreen text-white font-semibold px-4 py-1 rounded-md cursor-pointer">Order Now</span></Link>
                    </div>)}
                </div>
            </div>
        </>
    );
};

export default AllOrders;
